import VueInput from '@ui-common/vue-input';
export default {
	props: ['value', 'prefixMaxLength', 'numberMaxLength', 'hasError'],
	data() {
		return {
			prefix: '',
			phoneNumber: ''
		};
	},
	methods: {
		emitPhoneNUmber() {
			if (!this.prefix && !this.phoneNumber) {
				this.$emit('input', '');
			} else {
				this.$emit('input', `${this.prefix}-${this.phoneNumber}`);
			}
		},
		emitBlur() {
			this.$nextTick(function () {
				if (document.activeElement == this.$refs.prefix || document.activeElement == this.$refs.number) {
					return;
				} else {
					this.$emit('blur');
				}
			});
		}
	},

	components: {
		VueInput
	},

	mounted() {
		if (this.value) {
			this.prefix = this.value.substring(0, this.value.indexOf('-'));
			this.phoneNumber = this.value.substr(this.value.indexOf('-') + 1); // +1 azért kell, hogy a kötőjel ne legyen benne az input mezőben
		}
	}
};
